import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Col
} from "antd";
import {isIOS, isMacOs} from "react-device-detect";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalAdresseOpenWith extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        query: null,
        lat: null,
        long: null,
    };

    state = this.initialState

    async show(query, ll = null) {
        console.log("QUERY ", query, ll)
        this.setState({visible: true, loading: false, query: query, lat: ll?.lat, long: ll?.long})
    }

    getContactAdresseLatLong(contact, query) {
        const q = query?.replace(/\s{2,}/g, " ")

        console.log(contact.geos,q)

        if (Array.isArray(contact.geos)) {
            const match = contact.geos.find(i => i.query?.toLowerCase() == q?.toLowerCase())
            if (match) {
                return {lat: match.lat, long: match.long}
            }
        }
        return null
    }

    close() {
        this.setState(this.initialState)
    }

    render() {

        const {query, lat, long} = this.state

        let wazeUrl = "https://waze.com/ul?navigate=yes&q=" + encodeURI(query)
        let gmapUrl = "https://www.google.com/maps/search/?api=1&query=" + encodeURI(query)
        let applemapUrl = "https://maps.apple.com/?address=" + encodeURI(query)

        if (lat && long) {
            wazeUrl += "&ll=" + lat + "," + long
            gmapUrl += "&ll=" + lat + "," + long
            applemapUrl += "&ll=" + lat + "," + long
        }

        return (
            <Fragment>
                <Modal centered title={"Ouvrir Avec :"} open={this.state.visible} destroyOnClose closable footer={null}
                       onCancel={() => this.close()}>
                    {this.state.visible && (
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            paddingBottom: 25
                        }}>
                            <div style={{display: "flex", justifyContent: "space-around", width: "100%"}}>

                                <Button type={"text"} onClick={() => this.close()} href={wazeUrl} target="_blank">
                                    <img src="/img/brands/waze.png" style={{height: 60}}/>
                                </Button>

                                <Button type={"text"} onClick={() => this.close()} href={gmapUrl} target="_blank">
                                    <img src="/img/brands/google_maps.png" style={{height: 64.5, marginTop: -4}}/>
                                </Button>

                                {(isMacOs || isIOS) && (
                                    <Button type={"text"} onClick={() => this.close()} href={applemapUrl}
                                            target="_blank">
                                        <img src="/img/brands/apple_plans1.png" style={{height: 60, marginTop: 2}}/>
                                    </Button>
                                )}
                            </div>
                        </div>
                    )}
                </Modal>
            </Fragment>

        )
    }
}

